var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.94073 12.1691L0.69073 12.1691L0.69073 12.4191L0.69073 17.0859L0.69073 17.3359L0.94073 17.3359L5.60753 17.3359L5.85753 17.3359L5.85753 17.0859L5.85753 16.6518L5.85753 16.4018L5.60753 16.4018L2.28229 16.4018L7.78127 10.9028L7.95805 10.7261L7.78127 10.5493L7.47738 10.2454L7.30061 10.0686L7.12383 10.2454L1.62485 15.7444L1.62485 12.4191L1.62485 12.1691L1.37485 12.1691L0.94073 12.1691Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5149 7.91323L10.6941 8.08046L10.8648 7.90464L16.2811 2.32726L16.3178 5.64945L16.3206 5.89669L16.5678 5.89669L17.002 5.89669L17.2555 5.89669L17.2519 5.6432L17.1868 0.976394L17.1833 0.726419L16.9333 0.729907L12.2665 0.795024L12.0074 0.798639L12.0203 1.05748L12.042 1.4916L12.0541 1.73309L12.2959 1.72909L15.618 1.67402L10.1809 7.25208L10.0025 7.43503L10.1893 7.60935L10.5149 7.91323Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.65ab9b21.svg";
export { ForwardRef as ReactComponent };